import cn from 'classnames';
import styles from './BannerSpace.module.scss';

type BannerSpaceProps = {
  className?: string;
};

export function BannerSpace({ className }: BannerSpaceProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return <div className={wrapperClassName} />;
}
